export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#1A1A1A] text-[#FFFFFF]/55 border-t border-[#FFFFFF]/10">
      <div className="max-w-6xl mx-auto px-6 sm:px-10 py-10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="font-serif text-lg text-[#FFFFFF] flex items-center gap-2">
          <span className="inline-block w-2 h-2 rounded-full bg-[#6B8F71]" />
          Sanya Vithalkar
        </p>
        <p className="font-mono text-xs tracking-wide text-[#FFFFFF]/55">
          Systems into form · © {new Date().getFullYear()}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
